import ApplicationController from './application_controller.js'

export default class extends ApplicationController {
  static targets = ['checkbox']

  toggleAll(event) {
    const isChecked = event.target.checked
    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.value !== 'all') {
        checkbox.checked = isChecked
      }
    })
  }

  download(event) {
    const button = event.currentTarget
    const selectedCheckboxes = this.checkboxTargets.filter(
      (cb) => cb.checked && cb.value !== 'all'
    )

    if (selectedCheckboxes.length === 0) {
      alert('Please select at least one calculation to export')
      return
    }

    const calculations = selectedCheckboxes.map((cb) => cb.value).join(',')
    const date = button.dataset.date
    const resolution = button.dataset.resolution
    const unit = button.dataset.unit

    const url = `/admin/mscons_time_series/export_calculations_csv?date=${date}&resolution=${resolution}&unit=${unit}&calculation_identifiers=${calculations}`

    // Navigate to the URL to trigger download
    window.location.href = url
  }
}
